// extracted by css-extract-rspack-plugin
export default {"Sidebar":"DashboardChartSettings-module__Sidebar___sVpBO","Visualization":"DashboardChartSettings-module__Visualization___vot1e"};